<template>
  <div id="app" :class="{ menuHide: $root.menuHide, h5Model: $root.model == 'h5' }">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import '@/css/base.scss';
#app {
  margin: 0;
  min-width: 1200px;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.h5Model {
  min-width: unset!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue